import { Anchor } from 'components/atoms';
import UnternehmensTable from 'components/atoms/UnternehmensTable/UnternehmensTable';
import React from 'react';
import type { Eintragung } from 'types/eintragungen';
import { useTranslation } from 'utils/hooks';


interface TabTableProps 
{
  eintragungen: Eintragung[];
}

const Eintragungenlist: React.FC<TabTableProps> = (props) =>
{
  const { eintragungen } = props;
  const { t } = useTranslation();

  const columns = [
    t('eintragungen:table.name'),
    t('eintragungen:table.bundesland'),
    t('eintragungen:table.date'),
  ];

  const renderRow = (neueintragung: Eintragung) => (
    <tr key={neueintragung.fbNr}>
      <td className="">
        <Anchor href={`/u/${neueintragung.fbNr}`}>
          {t('formats:nameWithFbNr', { name: neueintragung.name, fbNr: neueintragung.fbNr })}
        </Anchor>
      </td>
      <td>{t(`bundesländer:shortList.${neueintragung.bundesland}`)}</td>
      <td>{t('formats:date', { value: neueintragung.datum })}</td>
    </tr>
  );

  return (
    <div id="results">
      <UnternehmensTable<Eintragung>
        columns={columns}
        data={eintragungen}
        renderRow={renderRow}
      />
    </div>
  );
};

export default Eintragungenlist;
